import React from "react";

type SignupErrorFeedbackProps = {
  children: React.ReactNode;
};

export const SignupErrorFeedback: React.FC<SignupErrorFeedbackProps> = ({ children }) => {
  return <div className="subtext-small capitalize text-red-light-500">{children}</div>;
};
